<template>
  <div>
    <Header />
    <slot />
<!--    <Footer />-->
    <FooterContact />
  </div>
</template>
<script setup lang="ts">
</script>